import { ChangeEvent, useCallback, useEffect,useState } from "react";


import useUiuxStore from "src/store/useUiuxStore";
import { usePUR1040_R01Store } from "./Store_PUR1040_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import {  SearchSpacer } from "src/components/common/common";

export const SearchSection_PUR1040_R01 = () => {
	const { PUR1040_R01Filter, setPUR1040_R01Filter } = usePUR1040_R01Store();

    const { setCodeSearchModalProps } = useUiuxStore();
    
	const { compCdList, customCdList, wmsCdList, itemGroupList, brandCdList , } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    const handleFilterCompanyChange = (selectedValue: string) => {
        setPUR1040_R01Filter({ compCd: selectedValue });
    }
	const handleFilterWmsChange = (selectedValue: string) => {
        setPUR1040_R01Filter({ logicCenter: selectedValue });
    }
	const handleFilterItemGroupChange = (selectedValue: string) => {
        setPUR1040_R01Filter({ itemGroup: selectedValue });
    }
	const handleFilterBrandChange = (selectedValue: string) => {
        setPUR1040_R01Filter({ brandCd: selectedValue });
    }

	// 거래처명 초기화 useEffect 추가
useEffect(() => {
    if (PUR1040_R01Filter.customCd === '') {
        setPUR1040_R01Filter({ customNm: '' });
    }
}, [PUR1040_R01Filter.customCd]);

// 발주자명 초기화 useEffect 추가
useEffect(() => {
    if (PUR1040_R01Filter.empNo === '') {
        setPUR1040_R01Filter({ empNm: '' });
    }
}, [PUR1040_R01Filter.empNo, setPUR1040_R01Filter]);

// 거래처 코드 입력
    const handleCustChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPUR1040_R01Filter({ customCd: e.target.value, customNm: e.target.value === '' ? '' : PUR1040_R01Filter.customNm });
    }

	const openCustSearchModal = useCallback((search: string) => {
		setCodeSearchModalProps({
			category: '거래처',
			search: search,
			formName: 'PUR1040_R01',
			isInfo: false,
			handleFoucsId: 'customCd_search',  // ✅ 추가
			onClear: () => {
				setPUR1040_R01Filter({ customCd: '', customNm: '' });
			},
			onConfirm: (data: any) => {
				setPUR1040_R01Filter({ customCd: data ? data.customCd : '', customNm: data?.customNm || '' });
			},
			onCloseConfirm: () => {},  // ✅ 추가
			wrapperOption: {  // ✅ 추가
				size: 'half',
				width: 50,
				overlay: true
			},
			processType_focus: 'normal',  // ✅ 추가
		});
	}, [PUR1040_R01Filter, setPUR1040_R01Filter, setCodeSearchModalProps]);  // ✅ 의존성 배열 수정


	const handleEmpChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPUR1040_R01Filter({ empNo: e.target.value, empNm: e.target.value === '' ? '' : PUR1040_R01Filter.empNm });
    }

    const handleCustDoubleClick = useCallback(async (e: React.MouseEvent<HTMLInputElement>) => {
        e.currentTarget.blur();
        openCustSearchModal(PUR1040_R01Filter.customCd);
    }, [PUR1040_R01Filter.customCd, openCustSearchModal])

	const openEmpSearchModal = useCallback((search: string) => {
		setCodeSearchModalProps({
			category: '발주자',
			search: search,
			formName: 'PUR1040_R01',
			isInfo: false,
			handleFoucsId: 'empNo_search',  // ✅ 추가
			onClear: () => {
				setPUR1040_R01Filter({ empNo: '', empNm: '' });
			},
			onConfirm: (data: any) => {
				setPUR1040_R01Filter({ empNo: data ? data.empNo : '', empNm: data?.empNm || '' });
			},
			onCloseConfirm: () => {},  // ✅ 추가
			wrapperOption: {  // ✅ 추가
				size: 'half',
				width: 20,
				overlay: true
			},
			processType_focus: 'normal',  // ✅ 추가
		});
	}, [PUR1040_R01Filter, setPUR1040_R01Filter, setCodeSearchModalProps]);  // ✅ 의존성 배열 수정

	const handleEmpDoubleClick = useCallback(async (e: React.MouseEvent<HTMLInputElement>) => {
		e.currentTarget.blur();
		openEmpSearchModal(PUR1040_R01Filter.empNo);
	}, [PUR1040_R01Filter.empNo, openEmpSearchModal])




    return (
		<>
		<SearchSectionDoubleForm >
			{/* 회사 선택 */}
			<SearchDropDownForm
				label="사업장"
                value={PUR1040_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={handleFilterCompanyChange}
			/>
			<SearchDateRangeForm
				label="발주기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
                dateRange={PUR1040_R01Filter.dateRange}		setDateRange={(dateRange) => setPUR1040_R01Filter({ dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="입고물류"
                value={PUR1040_R01Filter.logicCenter}
				optionList={wmsCdList}
				onChangeValue={handleFilterWmsChange}
			/>
			
			<SearchDropDownForm
				label="브랜드"
                value={PUR1040_R01Filter.brandCd}
				optionList={brandCdList}
				onChangeValue={handleFilterBrandChange}
			/>
			<SearchSpacer/>
			<SearchDropDownForm
				label="품목그룹"
                value={PUR1040_R01Filter.itemGroup}
				optionList={itemGroupList}
				onChangeValue={handleFilterItemGroupChange}
			/>

			
			<SearchCodeModalForm
				label="발주자"
                value={PUR1040_R01Filter.empNo}
                valueLabel={PUR1040_R01Filter.empNm}
				onChange={handleEmpChange}
				onDoubleClick={handleEmpDoubleClick}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
                        openEmpSearchModal(PUR1040_R01Filter.empNo);
					}
				}}
				wrapperOption={{
					wrapperStyle: "w-[260px] min-w-[260px]",
					titleStyle: "w-[45px] min-w-[45px] text-left",
					codeInputStyle: "w-[80px] min-w-[80px]",
					nameTagStyle: "w-[60px] min-w-[60px] text-left",
				}}
			/>
			
			<SearchCodeModalForm
				label="거래처"
                value={PUR1040_R01Filter.customCd}
				valueLabel={PUR1040_R01Filter.customNm}
				onChange={handleCustChange}
				onDoubleClick={handleCustDoubleClick}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
                        openCustSearchModal(PUR1040_R01Filter.customCd);
					}
				}}
			/>
		</SearchSectionDoubleForm>
		{/* searchedCustomer : {JSON.stringify(searchedCustomer)} */}
		</>
	)
}

export default SearchSection_PUR1040_R01;
